import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Box,
  Link
} from "@mui/material";
import { QRCodeCanvas } from "qrcode.react"; // ✅ QR Code Import

const CreateGift = () => {
  const [message, setMessage] = useState("");
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [giftId, setGiftId] = useState(null);

  // ✅ Cloudflare Pages URL
  const PUBLIC_URL = "https://gift-5gc.pages.dev";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setGiftId(null);  // Reset previous ID

    const formData = new FormData();
    formData.append("message", message);
    if (image) formData.append("image", image);

    try {
      const response = await fetch("http://localhost:5050/create-gift", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Failed to create gift. Please try again.");

      const data = await response.json();
      console.log("Generated Gift ID:", data.giftId);
      setGiftId(data.giftId);
      setMessage("");
      setImage(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container sx={{ mt: 5 }}>
      <Card sx={{ p: 3, backgroundColor: "#121212", color: "#fff", border: "1px solid #0f0" }}>
        <CardContent>
          <Typography variant="h5" sx={{ color: "#0f0", fontWeight: "bold" }}>
            Create Your Gift
          </Typography>

          <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Enter your message..."
              variant="outlined"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              sx={{
                mb: 2,
                input: { color: "#fff" },
                label: { color: "#0f0" },
                fieldset: { borderColor: "#0f0" },
              }}
            />

            <input
              type="file"
              accept="image/*,video/*"
              onChange={(e) => setImage(e.target.files[0])}
              style={{ display: "block", marginBottom: "20px", color: "white" }}
            />

            {error && <Typography color="error">{error}</Typography>}

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={loading}
              sx={{ backgroundColor: "#0f0", "&:hover": { backgroundColor: "#0d0" } }}
            >
              {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Generate Gift Link"}
            </Button>
          </form>

          {/* ✅ Show QR Code after gift is created */}
          {giftId && (
            <Box sx={{ textAlign: "center", mt: 3 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Scan to view your gift:
              </Typography>
              <QRCodeCanvas value={`${PUBLIC_URL}/gift/${giftId}`} size={150} />

              {/* ✅ Clickable Link */}
              <Typography variant="body2" sx={{ mt: 2 }}>
                <Link href={`${PUBLIC_URL}/gift/${giftId}`} target="_blank" rel="noopener noreferrer" color="secondary">
                  Click here if QR code doesn't work
                </Link>
              </Typography>
            </Box>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default CreateGift;
